import ErrorMessage from 'components/ErrorMessage'
import Panel from 'components/Panel'
import styled from 'styled-components'
import { breakpoint } from 'utils'

export const StyledPanel = styled(Panel)`
  max-width: 520px;
  margin: auto;
`

export const UberHeader = styled.div`
  display: flex;
  align-items: center;
  padding: 28px 16px;

  ${breakpoint('xs')`
    padding: 28px 48px;
  `}
`

export const StyledHeader = styled(Panel.Header)`
  padding-top: 24px;
`

export const Separator = styled.div`
  height: 1px;
  width: 100%;

  background-color: ${({ theme }) => theme.colors.border.dark.base};
`

export const FormContainer = styled.div`
  margin-top: 32px;
`

export const GenericErrorMessage = styled(ErrorMessage.Generic)`
  flex: 1 1 100%;
`
